<template>
  <div class="sidebar xs-12 m-4">
    <slot />
  </div>
</template>

<script>
export default {
  name: "SidebarMyhome",
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.sidebar {
  padding-top: $space-base;
}
</style>
